module.exports = __webpack_public_path__ + "img/rank-teacher-pic003.2e384a91.png";